module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//20.jpg?b945423667260c722c050b51b0c9e929";